import type { RubricDto } from '../types';

// Phase-D rubric fixtures — the versioned thesis config the admin Rubric editor edits.
// v1 mirrors the four fit dimensions every fixture score already cites; dimension
// weights and sub-segment weights each sum to exactly 1.0 (the server-side invariant
// the editor mirrors client-side).

export const RUBRIC_VERSIONS: RubricDto[] = [
  {
    version: 'v1',
    createdAt: '2026-03-20T12:00:00Z',
    active: true,
    dimensions: [
      {
        key: 'product_adjacency',
        label: 'Product adjacency',
        weight: 0.35,
        definition:
          'How directly the target’s products or services sit next to the HMH drilling-equipment portfolio: vertical adjacency (powers/serves what we build) and horizontal adjacency (fills a portfolio gap) score high; head-on model overlap scores low.',
      },
      {
        key: 'aftermarket_attach',
        label: 'Aftermarket attach',
        weight: 0.25,
        definition:
          'Size and separability of the recurring revenue surface — installed base, service share of revenue, recertification/spares books — that the combined aftermarket network could monetise.',
      },
      {
        key: 'technology_differentiation',
        label: 'Technology differentiation',
        weight: 0.2,
        definition:
          'Proprietary technology, patents, type approvals or software moats that are scarce in the segment. Workshop capability without IP scores low.',
      },
      {
        key: 'size_feasibility',
        label: 'Size feasibility',
        weight: 0.2,
        definition:
          'Whether the deal fits the $5–500M envelope, including asset-level entries (§363 lots, carve-outs). Carve-out complexity discounts the score.',
      },
    ],
    subSegmentWeights: {
      drilling_equipment_oem: 0.3,
      components: 0.15,
      aftermarket_service: 0.25,
      automation_digital: 0.2,
      rig_electrification: 0.1,
      mining_equipment_supply: 0.1,
    },
    mustHaves: [
      'Revenue (or asset value) inside the $5–500M envelope',
      'HMH-adjacent drilling equipment, component, service or software scope',
      'Identifiable legal entity with at least one filed financial year or an active court process',
    ],
    exclusions: [
      'Pure E&P operators',
      'Drilling contractors (rig owners) as whole-company targets',
      'Majority state-controlled ownership',
      'Sanctioned jurisdictions or counterparties',
    ],
  },
];

/** The active rubric — what GET admin/rubric serves. */
export const RUBRIC: RubricDto = RUBRIC_VERSIONS.find((r) => r.active) ?? RUBRIC_VERSIONS[0];
